export * from "./envCubeTexture.pure";

import "../../Materials/Textures/baseTexture.polynomial";
